
/////////////////////////////////////////////////////////////////////////
// BaseAppState //////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////
const BaseAppState = {

  timePlayed: 0,  // count-up timer
  timerStartTime: 0,
  isActive: false,

  init: function(game, stateName) {

    this.game = game;
    this.name = stateName;

    return this;
  },
		  
  reset: function() {

    // Is this necessary? Seems onEnter should take care of resetting the state.
    // May need if states need to reset before entering - ie. clearing something in the UI.
    // In Bej code, all the GamePlay substates are reset in GamePlayState.onEnter
    // We'll see...
  },
  
  _onEnter: function() {

    this.timePlayed = 0;
    this.timerStartTime = Date.now();
    this.isActive = true;
  },

  _onExit: function() {

    this.isActive = false;
  },

  _onPush: function() {

    this.isActive = false;
  },

  _onPop: function() {

    this.isActive = true;
  },

  _update: function() {
    
    var elapsed = Math.max(15, this.game.time.elapsed);  // in ms
    this.timePlayed += elapsed;
  },

  _render: function() {
    // use this for debug shapes
  }
  

};

export default BaseAppState;





		




// WEBPACK FOOTER //
// ./app/src/utils/statemachine/BaseAppState.js